import React from 'react';
import classNames from "classnames";
import Modal from "react-responsive-modal";
import IconCheck from '../../../../icons/check';

const ModalContext = React.createContext(null);

const ModalHeader = (props) => {
    const {
        title,
        className,
    } = props;

    const modalContext = React.useContext(ModalContext);

    return (
        <React.Fragment>
            <div className={classNames("d-flex flex-wrap px-4 pt-4", className)}>
                <div className="col-12 d-flex justify-content-between">
                    <h4 className="fw-600">{title}</h4>
                    <button type="button" className="close" data-dismiss="modal"
                        onClick={modalContext.onClose}
                    >
                        <span className="fw-700 h3">×</span>
                    </button>
                </div>
            </div>
            <hr/>
        </React.Fragment>
    )
}

const ModalFooter = (props) => {
    const {
        closeText = "Cancel",
        confirmText = "Save Changes",
        variant = "primary",
        idForm,
        className,
        children,
    } = props;

    const modalContext = React.useContext(ModalContext);

    return (
        <React.Fragment>
            <hr/>
            <div className="w-100 px-4 pb-4">
                {children ? (
                    children
                ) : (
                    <div className={classNames("d-flex justify-content-end", className)}>
                        <button type="button"
                            className="btn btn-outline-secondary px-3 py-2 m-1"
                            onClick={modalContext.onClose}
                        >
                            <span className="fw-600">{closeText}</span>
                        </button>
                        <button type="submit"
                            form={idForm}
                            className={classNames("btn px-3 py-2 m-1", {
                                "btn-primary": variant == "primary",
                                "btn-warning": variant == "warning"
                            })}
                        >
                            <IconCheck className="vendor-icon"/>
                            <span className="fw-600 ml-2">{confirmText}</span>
                        </button>
                    </div>
                )}
            </div>
        </React.Fragment>
    )
}

const ModalVendor = (props) => {
    const {
        onClose,
        onConfirm,
        children,
        ...restProps
    } = props;

    return (
        <ModalContext.Provider
            value={{
                onClose,
                onConfirm
            }}
        >
            <Modal
                onClose={onClose}
                center={false}
                showCloseIcon={false}
                classNames={{
                    modal: "p-0 mt-0"
                }}
                styles={{
                    modal: { borderRadius: 12 }
                }}
                {...restProps}
            >
                {children}
            </Modal>
        </ModalContext.Provider>
    )
}

ModalVendor.Header = ModalHeader;
ModalVendor.Footer = ModalFooter;

export default ModalVendor
